import request from '@/utils/request'

/**
 * @Description: 回款数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getCollectionStatisticsData(params) {
  return request({
    url: '/je/project/sxft/collection/statistics/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 回款数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getCollectionStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/collection/statistics/data/detail',
    method: 'post',
    data,
    params
  })
}

/**
 * @Description: 合同支出数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getExpendContractStatisticsData(params) {
  return request({
    url: '/je/project/sxft/contract/expend/statistics/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 合同支出数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getExpendContractStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/contract/expend/statistics/data/detail',
    method: 'post',
    data,
    params
  })
}

/**
 * @Description: 合同收入数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getIncomContractStatisticsData(params) {
  return request({
    url: '/je/project/sxft/contract/income/statistics/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 合同收入数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getIncomeContractStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/contract/income/statistics/data/detail',
    method: 'post',
    data,
    params
  })
}

/**
 * @Description: 项目迄今数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getOverallProjectStatisticsData(params) {
  return request({
    url: '/je/project/sxft/project/statistics/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 项目迄今数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getOverallProjectStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/project/statistics/data/detail',
    method: 'post',
    data,
    params
  })
}

/**
 * @Description: 项目月度数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getMonthProjectStatisticsData(params) {
  return request({
    url: '/je/project/sxft/project/statistics/month/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 项目月度数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getMonthProjectStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/project/statistics/month/data/detail',
    method: 'post',
    data,
    params
  })
}
/**
 * @Description: 现金流数据-数据看板-汇总数据
 * @param {*} params
 * @return {*}
 */
export function getCashStatisticsData(params) {
  return request({
    url: '/je/project/sxft/cash/statistics/data',
    method: 'post',
    data: params
  })
}
/**
 * @Description: 现金流数据-数据看板-明细列表
 * @param {*} params 分页参数
 * @param {*} data body参数
 * @return {*}
 */
export function getCashStatisticsDetail(params, data) {
  return request({
    url: '/je/project/sxft/cash/statistics/data/detail',
    method: 'post',
    data,
    params
  })
}
/**
 * @Description: 现金流类型
 */
export function getCashType() {
  return request({
    url: '/je/project/sxft/cash/statistics/type',
    method: 'post'
  })
}
